/* =============================================================================
   packs-offer.js: ChooseYourPack's client state (sections/undepleted-packs.liquid).
   Ports app/components/home/funnel/ChooseYourPack.tsx + useAddToCart.ts.

   - The tiers are one native radio group (name="offer-pack"); the row and dot
     styling is pure CSS (has-[:checked] / group-has-[:checked]), exactly as live.
   - The selection is React state (_index.tsx selectedId): it starts at the
     route's anchor pack (rendered as the `checked` attribute), lives in
     `selected` here, and the radio group is controlled from it, so the checked
     radio, the button and what Add to cart adds are always the same pack.
   - History. Live never leaves its document, so Back (or a reload) re-mounts
     the module at the anchor pack. Here Back either restores the page from the
     back/forward cache exactly as it was left, or loads it again, and then
     Chrome re-checks the radio the shopper had left checked AFTER this script
     ran (measured: after DOMContentLoaded, before load) and without a change
     event. Both arrive through `pageshow`, which re-mounts the state at the
     anchor pack as live does, unless the shopper already picked a pack in this
     document. (Without it: Back from /cart showed the 5-Pack checked under a
     "3 bottles, $118" button, and the click added a second 5-Pack.)
   - On every change the button carries the chosen tier: "<label>, <span>$price</span>",
     and is disabled when that pack cannot be bought.
   - Shop Pay Installments (CRO plan H8): Shopify's payment_terms element follows the id input
     of its own product form (#offer-installments). Every render writes the chosen pack's id
     there and dispatches a bubbling change so Shopify recalculates the line. It never adds
     anything to the cart.
   - Add to cart: QUANTITY 1 of the selected pack variant. The pack IS the variant
     ("3-Pack" is one $118 line); the bottle count only feeds the copy. Passing it
     here once sent 3 x $118 = $354 to checkout. Live's /cart action answers 303 to
     /cart whatever the add returned, so any HTTP answer lands on /cart.
   ========================================================================== */
(function () {
  'use strict';

  var section = document.getElementById('offer');
  var dataEl = document.getElementById('offer-packs-data');
  if (!section || !dataEl) return;

  var packs;
  try {
    packs = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var radios = Array.prototype.slice.call(
    section.querySelectorAll('input[type="radio"][name="offer-pack"]'),
  );
  var button = section.querySelector('button[type="button"]');
  if (!button || !button.lastElementChild || radios.length !== packs.length) return;
  var summary = button.lastElementChild;

  var termsForm = document.getElementById('offer-installments');
  var termsInput = termsForm ? termsForm.querySelector('input[name="id"]') : null;

  // Point the installments line at the chosen pack (force: also when the id is already there,
  // because Shopify's element is rendered for the product's first variant).
  function syncTerms(pack, force) {
    if (!termsInput || !pack) return;
    var id = String(pack.id);
    if (!force && termsInput.value === id) return;
    termsInput.value = id;
    var terms = termsForm.querySelector('shopify-payment-terms');
    if (terms && terms.getAttribute('variant-id') !== id) terms.setAttribute('variant-id', id);
    termsInput.dispatchEvent(new Event('change', {bubbles: true}));
  }

  var routes = window.Shopify && window.Shopify.routes;
  var root = (routes && routes.root) || '/';
  var busy = false;

  // The route's anchor pack: the radio server-rendered with `checked`.
  var initial = 0;
  for (var i = 0; i < radios.length; i++) {
    if (radios[i].defaultChecked) {
      initial = i;
      break;
    }
  }
  var selected = initial;
  var picked = false; // the shopper chose a pack in this document

  // The summary is SSR'd as React leaves it: "3 bottles<!-- -->,<!-- --> <span>$118</span>".
  // React updates only the label text node and the price span, so do exactly that.
  function render() {
    var pack = packs[selected];
    if (!pack) return;
    radios.forEach(function (radio, index) {
      if (radio.checked !== (index === selected)) radio.checked = index === selected;
    });
    var labelNode = summary.firstChild;
    var money = summary.querySelector('span');
    if (labelNode && labelNode.nodeType === 3 && money) {
      if (labelNode.nodeValue !== pack.label) labelNode.nodeValue = pack.label;
      if (money.textContent !== pack.price) money.textContent = pack.price;
    } else {
      money = document.createElement('span');
      money.textContent = pack.price;
      summary.textContent = pack.label + ', ';
      summary.appendChild(money);
    }
    button.disabled = !pack.available;
    syncTerms(pack, false);
  }

  // useState(selectedId) on mount: the anchor pack, whatever the browser restored.
  function mount() {
    selected = initial;
    picked = false;
    render();
    syncTerms(packs[selected], true);
  }

  radios.forEach(function (radio, index) {
    radio.addEventListener('change', function () {
      if (!radio.checked) return;
      selected = index;
      picked = true;
      render();
    });
  });
  mount();

  button.addEventListener('click', function () {
    // Re-assert the controlled group first: what shows checked is what is added.
    render();
    var pack = packs[selected];
    if (!pack || !pack.available || busy) return;
    busy = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: [{id: Number(pack.id), quantity: 1}]}),
    }).then(
      function () {
        window.location.assign(root + 'cart');
      },
      function () {
        busy = false;
      },
    );
  });

  // Back / forward / reload: never leave the button locked, and re-mount at the
  // anchor pack like live (a back/forward-cache restore always; a fresh load
  // only if the shopper has not picked yet, which also undoes Chrome's silent
  // restore of the radio that runs after this script).
  // Shopify's payment-terms script may upgrade its element after this file ran.
  window.addEventListener('load', function () {
    syncTerms(packs[selected], true);
  });

  window.addEventListener('pageshow', function (event) {
    busy = false;
    if (event.persisted || !picked) mount();
  });
})();
